import React from 'react';
import { createRoot } from 'react-dom/client';
import { Route, HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import appStore from './store/appStore';
import App from './containers/App';
import './assets/scss/index.scss';
import GA4Listener from 'Components/GAListener/GA4Listener.js';
import { setGlobal, addCallback } from 'reactn';
import { LicenseManager } from '@ag-grid-enterprise/core';
import LogRocket from './store/logrocket';
import setupLogRocketReact from 'logrocket-react';
import { VITE_LOGROCKET_APP_ID } from 'Constants/appEnvConstants';
import { defineCustomElements } from '@mxp/gp-apptray/loader';

// Initialize @mxp/gp-apptray web components with proper resource path
defineCustomElements(window);

//initialize the logrocket before rendering the app
if (VITE_LOGROCKET_APP_ID) {
  LogRocket.init(VITE_LOGROCKET_APP_ID, {
    network: {
      requestSanitizer: request => {
        if (
          request?.url?.toLowerCase().includes('detokenize') ||
          request?.url?.toLowerCase().includes('tokenization')
        ) {
          return null;
        }
        return request;
      },
    },
  });
  setupLogRocketReact(LogRocket);
  console.log('********* Logrocket initialized before rendering the app *********');
};

const container = document.getElementById('app');
const root = createRoot(container);
const store = appStore();

// initial state for V2 (ReactN.useGlobal)
const initialGlobalState = {
  ...store.getState(),
};
setGlobal(initialGlobalState);

let isSynchingFromV2 = false;
let isSynchingFromRedux = false;

// subscribe to redux store and push changes from redux to V2
store.subscribe(() => {
  const newState = store.getState();
  // if this Redux update came from V2 then no need to update V2 store
  if (!isSynchingFromV2) {
    isSynchingFromRedux = true;
    setGlobal({
      ...newState,
    });
    isSynchingFromRedux = false;
  }
});

// subscribe to V2 global store, and push changes from V2 to Redux
addCallback(g => {
  // if this V2 update came from Redux then no need to update Redux store
  if (!isSynchingFromRedux) {
    isSynchingFromV2 = true;
    store.dispatch({ type: 'SYNC_STATE_FROM_V2_STORE', newState: { ...g } });
    isSynchingFromV2 = false;
  }
  return null;
});

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-076250}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TSYS}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{I2I}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{I2I}_need_to_be_licensed___{I2I}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_April_2026}____[v3]_[01]_MTc3NTUxNjQwMDAwMA==19c41a91f120827ebaad66ae916a7019");
root.render(
  <Provider store={store}>
    <HashRouter>
      <div>
        <GA4Listener>
            <Route path="/" component={App} />
          </GA4Listener>
      </div>
    </HashRouter>
  </Provider>
);
